import React from "react";
import PropTypes from "prop-types";

const Title = ({ title }) => {
  return (
    <h2 className="mb-2 mt-8 text-lg font-bold uppercase tracking-wide text-gray-900 first:mt-0">
      {title}
    </h2>
  );
};

Title.propTypes = {
  title: PropTypes.string,
};

export default Title;
